module.exports = __webpack_public_path__ + "img/14.fdc65e2b.jpg";